<template>
  <section>
    <el-row class="warp">
        <el-col :span="6" class="warp-breadcrum">
            <el-breadcrumb separator="/">
            <!--
                <el-breadcrumb-item :to="{ path: '/' }">
                <b>首页</b>
                </el-breadcrumb-item>
            -->
                <el-breadcrumb-item>单篇数据下载列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-col>
    </el-row>  

      <!--工具条 begin-->
        <el-row class="warp">
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item>
                    <el-button size="mini" type="primary" @click="refresh(null)">刷新</el-button>
                </el-form-item>
            </el-form>
        </el-col>
      <!--工具条 end-->

      <!-- 列表显示 begin-->
        <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
            <el-table :data="individualTasks" style="width: 100%;overflow: auto;" stripe border highlight-current-row v-loading="pageLoading" element-loading-text="文件上传中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="源文件：">
                        <span>{{ props.row.unProcessFileName }}</span>
                      </el-form-item>
                      <el-form-item label="源文件路径：">
                        <span>{{ props.row.unProcessFilePath }}</span>
                      </el-form-item>
                      <el-form-item label="加工文件：">
                        <span>{{ props.row.processedFileName }}</span>
                      </el-form-item>
                      <el-form-item label="加工文件路径：">
                        <span>{{ props.row.processedFilePath }}</span>
                      </el-form-item>
                      <el-form-item label="任务创建用户：">
                        <span>{{ props.row.createUser }}</span>
                      </el-form-item>
                      <el-form-item label="任务加工用户：">
                        <span>{{ props.row.processedUser }}</span>
                      </el-form-item>
                      <el-form-item label="源文件下载时间：">
                        <span>{{ props.row.downloadTime }}</span>
                      </el-form-item>
                      <el-form-item label="加工文件上传时间：">
                        <span>{{ props.row.finishTime }}</span>
                      </el-form-item>
                      <el-form-item label="doi:">
                        <span>{{ props.row.doi }}</span>
                      </el-form-item>
                      <el-form-item label="issn:">
                        <span>{{ props.row.issn }}</span>
                      </el-form-item>
                      <el-form-item label="volume:">
                        <span>{{ props.row.volume }}</span>
                      </el-form-item>
                      <el-form-item label="issue:">
                        <span>{{ props.row.issue }}</span>
                      </el-form-item>
                  </el-form>
                </template>
            </el-table-column>
            <!-- 第一行显示数据 -->
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column prop="doi" label="文章DOI" sortable align="center"></el-table-column>
                <el-table-column prop="issn" label="期刊ISSN" sortable align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" sortable align="center"></el-table-column>
                <el-table-column prop="dataType" label="数据类型" sortable align="center"></el-table-column>
                <el-table-column prop="status" label="任务状态" sortable align="center">
                    <template slot-scope="scope">
                        <el-tag
                            :type="scope.row.status === 2 || scope.row.status === 4 ? 'success' : 'danger'"
                            disable-transitions>
                            {{scope.row.statusInfo}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="下载" width="240" align="center">
                    <template slot-scope="scope">
                        <el-button size="small" type="danger" @click="downLoad(scope.row)" :style="(scope.row.status === 1 || scope.row.status === 3 || scope.row.status === 4 || scope.row.status === 5) ? { display: '' } : { display: 'none' }" >下载源数据</el-button>
                    </template>
                </el-table-column>
                <!-- 操作按钮 -->
                <el-table-column label="上传" width="240" align="center">
                    <template slot-scope="scope">
                        <el-upload
                        class="upload-demo"
                        :ref="uploadDemo + scope.$index"
                        :action="packageUrl(flag,scope.row)"
                        :limit="1"
                        :file-list="fileList"
                        :on-success="uploadApkSuccess"
                        :before-upload="beforeUpload"
                        :auto-upload="false"
                        :on-change="changeFile"
                        >
                            <el-button size="small" type="success" @click="uploadClick(scope.$index)" :style="(scope.row.status === 3 || scope.row.status === 4 || scope.row.status === 5) ? { display: '' } : { display: 'none' }">上传加工数据</el-button>
                        </el-upload>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
      <!-- 列表显示 end-->
      <!--底部分页-->
        <el-col :span="24" class="foolbar">
            <!-- hide-on-single-page  -->
            <el-pagination 
                background 
                layout="total, sizes, prev, pager, next"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pageSize"
                :page-sizes = pageSizes
                :total="total" 
                hide-on-single-page 
                style="float:right;">
            </el-pagination>
        </el-col>
    </el-row>
  </section>
</template>

<script>
import API_INDIVIDUAL from "../../../api/api_individual";
import API_LOG from "../../../api/api_log";

export default {
  data() {
    return {
        flag: '',
        uploadDemo:"uploadDemo",
        uploadName:"",
        individualTasks: [],
        //页码
        page: 1,
        //每页数量
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        //总数
        total: 0,
        clientHeight: window.innerHeight - 258,
        //页面载入状态
        pageLoading: false,
        fileList: [],
      //在此添加新的数据定义
    };
  },

  methods: {
    findAllIndividualTasks(){
        let that = this;
        let params = {
            page: that.page,
            pageSize: that.pageSize,
        };
        API_INDIVIDUAL.getAllIndividualTasks(params)
        .then(res=>{
            if(res && res.individualTasks){
            that.individualTasks = Object.values(res.individualTasks);
            that.total = res.total;
            console.log(
                "......findAllIndividualTasks:" + JSON.stringify(that.individualTasks)
                );
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求出现异常",
            duration:2000
            });
        });
    },

    downLoad: function(row) {
      console.log("........downLoad:" + JSON.stringify(row));
      let that = this;
      that.pageLoading = true;
      let params = {
        transUrl: row.unProcessFilePath,
        individualId:row.id
      };
      API_LOG.downloadZip(params)
        .then(res => {
          if (navigator.userAgent.match(/MSIE\s([\d.]+)/) ||navigator.userAgent.indexOf("Trident") > -1) {
                window.navigator.msSaveBlob(res, row.processDataName);
          } 
          else {
            const blob = new Blob([res]);
            const fileName = row.unProcessFileName;
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
          that.pageLoading = false;
          that.refresh();
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
          that.pageLoading = false;
          that.refresh();
        });
    },

    packageUrl(flag,row)
    {
      //debugger;
      flag = '3';
      return  "api/individualTask/fileUpload?flag="+flag+"&id="+row.id;
    },

    changeFile(file){
      if(file.status == 'ready'){
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          message: h('p', null, [
            h('span', null, '请确定是否上传?'),
            //('i', { style: 'color: red' }, this.selectedLabel),
            //h('span',null,' 类型的文件?')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.submitUpload();
        }).catch(() => {
            this.$refs[`${this.uploadName}`].clearFiles();
            this.$message({
              type: 'info',
              message: '取消文件上传'
            });
        });
      }
    },

    uploadClick(index){
      console.log("uploadClick index:"+index);
      console.log("uploadClick refs",this.$refs);
      this.uploadName = "uploadDemo"+index;
    },

    submitUpload() {
      console.log(this.$refs[`${this.uploadName}`]);
      console.log("submitUpload:" + this.uploadName);
      
      this.$refs[`${this.uploadName}`].submit();
    },

    beforeUpload(){
      this.pageLoading = true;  
    },

    uploadApkSuccess(response, fileList) {
      //console.log('response ----> ',response);
      //console.log('fileList ----> ',fileList);
      if(response.errorCode != 0)
      {
          this.$message({
          showClose: true,
          type: "info",
          message: response.errorInfo,
          duration: 2000
        });
        this.fileList= [];
        this.pageLoading = false;
        this.refresh();
        return;
      }
      else{
        this.fileList= [];
        this.pageLoading = false;
        this.refresh();
      }
    },

    getRows: function(_page) {
        this.page = _page;
        this.findAllIndividualTasks();
    },

    handleSizeChange(val) {
        this.pageSize = val;
        this.findAllIndividualTasks();
    },

    //分页选择处理
    handleCurrentChange: function(val) {
      this.getRows(val);
    },

    //初始化表格高度
    initHeight: function() {
      this.clientHeight = (document.documentElement.clientHeight - 258) + 'px';
    },

    refresh(){
      //点击查询按钮，分页初始化为1
      let _page = 1;
      //重新搜索时进行重置
      this.total = 0;
      //查询前清除查询列表信息
      this.individualTasks = null;
      //进行分页查询
      this.getRows(_page);
    },

  },
  mounted() {
    window.addEventListener('resize', this.initHeight);
    this.initHeight();
    this.findAllIndividualTasks();
  },
};
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Data/individualDownload.vue